import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";

export const occurrenceSyncRunsArgs = (projectNo: number) => ({ projectNo, limit: 100, offset: 0 });

export function makeSelectOccurrenceSyncRuns(projectNo: number) {
  const selectRunsQuery = openapi.endpoints.getMultiplacerDrofusInterfaceRuns.select(
    occurrenceSyncRunsArgs(projectNo)
  );
  return createSelector([selectRunsQuery], (query) => ({
    latest: query.data?.items[0] ?? null,
    running:
      query.data?.items.find((run) => run.status === "queued" || run.status === "running") ?? null,
  }));
}
